import { connect } from 'react-redux';

import { SortWidgetLayout } from 'components';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { setActiveSortButton } from 'store/ProductDetails/delivery/actions';
import {
  getDeliverySortActiveButton,
  getDeliverySortButtons,
  getDeliverySortReverseState,
} from 'store/ProductDetails/delivery/selectors';
import { getDeliveryOfficesList } from 'store/ProductDetails/selectors';

const mapStateToProps = (state) => ({
  activeButtonSlug: getDeliverySortActiveButton(state),
  buttons: getDeliverySortButtons(state),
  isMobile: isScreenBelow800(state),
  points: getDeliveryOfficesList(state),
  reverseState: getDeliverySortReverseState(state),
});

const mapDispatchToProps = {
  sortButtonClick: setActiveSortButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(SortWidgetLayout);
